import { PrecogSignalExternalService } from '@square/dashboard-protos/models/squareup/precog/v2/signals/external';
import rpc from '@square/dashboard-utilities/clients/rpc';
export default PrecogSignalExternalService.create(rpc());